<template>
    <div ref="form">
        <div class="vx-card__title mb-4">
            <h4 class="mb-4">Forgot Password</h4>
            <p>Confirm your email address and we'll send you a link to reset your password.</p>
        </div>

        <div>
            <vs-input
                name="email"
                icon-no-border
                icon="icon-user"
                icon-pack="feather"
                placeholder="Email"
                v-model="localEmail"
                v-validate="'required|email'"
                class="w-full inline-validation mt-2"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
                val-icon-success="icon-check"
                @keyup.enter="submit"
                :success="!!email && !errors.has('email')"
                :danger="errors.has('email')"
                :danger-text="errors.first('email')"
            />

            <vs-button tabindex="-1" class="mt-4" @click="$emit('cancel')" type="border"
                >Cancel</vs-button
            >
            <vs-button :disabled="!validated" class="float-right mt-4" @click="submit"
                >Submit</vs-button
            >
        </div>
    </div>
</template>

<script>
export default {
    name: 'forgot-password',
    props: {
        email: {
            type: String,
            required: true
        }
    },
    computed: {
        localEmail: {
            get() {
                return this.email
            },
            set(val) {
                this.$emit('update:email', val)
            }
        },
        validated() {
            return !this.errors.any() && this.localEmail != ''
        }
    },
    methods: {
        async submit() {
            if (await this.$validator.validate()) {
                try {
                    this.startLoad(this.$refs.form)
                    var minDelay = this.delayFor(1000)
                    const payload = {
                        email: this.localEmail
                    }
                    await this.$api.auth.request_password_reset(this.email)
                    await minDelay
                    this.notifySuccess(
                        'Password Reset Sent',
                        `We have sent a link to ${this.email}.<br><br>Please check your email to reset your password.`,
                        5000
                    )
                    this.endLoad(this.$refs.form)
                    this.$emit('cancel')
                } catch (error) {
                    this.notifyServerError(error)
                    this.endLoad(this.$refs.form)
                }
            }
        }
    }
}
</script>
